import React, { useState } from 'react';
import axios from 'axios';

const EncuestaServicio = ({ encuesta, token, nombreMecanico, nombreVendedor, nombreCliente }) => {
    const [calificacionVendedor, setCalificacionVendedor] = useState('');
    const [calificacionMecanico, setCalificacionMecanico] = useState('');
    const [tipoServicio, setTipoServicio] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [aceptaPoliticaDatos, setAceptaPoliticaDatos] = useState(false);
    const [mensaje, setMensaje] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorPolitica, setErrorPolitica] = useState('');
    const [errorCalificacionVendedor, setErrorCalificacionVendedor] = useState('');
    const [errorCalificacionMecanico, setErrorCalificacionMecanico] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validar si se seleccionó una calificación para el vendedor
        if (!calificacionVendedor) {
            setErrorCalificacionVendedor('Debes seleccionar una calificación para el vendedor.');
            return;
        }

        // Validar si se seleccionó una calificación para el mecánico
        if (!calificacionMecanico) {
            setErrorCalificacionMecanico('Debes seleccionar una calificación para el mecánico.');
            return;
        }

        // Validar si se aceptó la política de datos
        if (!aceptaPoliticaDatos) {
            setErrorPolitica('Debes aceptar la política de tratamiento de datos personales.');
            return;
        }

        setIsSubmitting(true);
        setErrorCalificacionVendedor('');
        setErrorCalificacionMecanico('');
        setErrorPolitica('');

        try {
            const response = await axios.post(`/api/encuestas/responder/${token}`, {
                calificacion_vendedor: calificacionVendedor,
                calificacion_mecanico: calificacionMecanico,
                tipo_servicio: tipoServicio,
                observaciones: observaciones,
                aceptaPoliticaDatos: aceptaPoliticaDatos,
            });
            setMensaje(response.data.message);
            window.location.reload();
        } catch (error) {
            console.error('Error al enviar la encuesta:', error);
            setMensaje('Error al enviar la encuesta.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="max-w-6xl mx-auto bg-white shadow-lg rounded-lg">
            <img src="https://osoriorepuestos.s3.amazonaws.com/osoapi/encuesta-header.png" alt="Encabezado de Encuesta" />
            <div className="p-8">
                <h3 className="text-6xl font-bold text-yellow-500 mb-4 text-center">¡Hola!</h3>
                <h3 className="text-center">
                    <strong>{nombreCliente}</strong>
                </h3>
                <br />
                <p>Tu opinión sobre nuestro servicio es muy importante para nuestra mejora constante. Por favor tómate 5 minutos de tu tiempo para responder.</p>
                <br />

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Calificación del Vendedor */}
                    <div>
                        <label className="block font-semibold text-gray-700 mb-2">
                            Por favor califica de 1 a 5 el servicio prestado por el vendedor <span className="text-yellow-500">{nombreVendedor}</span>, siendo 5 excelente y 1 insuficiente:
                        </label>
                        <div className="flex items-center space-x-4 text-3xl text-yellow-500">
                            {[1, 2, 3, 4, 5].map((num) => (
                                <button
                                    key={num}
                                    type="button"
                                    className={`border-2 border-yellow-500 rounded-full p-2 ${calificacionVendedor === num ? 'bg-yellow-500 text-white' : 'bg-white text-yellow-500'}`}
                                    onClick={() => setCalificacionVendedor(num)}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                        {errorCalificacionVendedor && <p className="text-red-500 text-sm">{errorCalificacionVendedor}</p>}
                    </div>

                    {/* Calificación del Mecánico */}
                    <div>
                        <label className="block font-semibold text-gray-700 mb-2">
                            Por favor califica de 1 a 5 el servicio prestado por el mecánico <span className="text-yellow-500">{nombreMecanico}</span>, siendo 5 excelente y 1 insuficiente:
                        </label>
                        <div className="flex items-center space-x-4 text-3xl text-yellow-500">
                            {[1, 2, 3, 4, 5].map((num) => (
                                <button
                                    key={num}
                                    type="button"
                                    className={`border-2 border-yellow-500 rounded-full p-2 ${calificacionMecanico === num ? 'bg-yellow-500 text-white' : 'bg-white text-yellow-500'}`}
                                    onClick={() => setCalificacionMecanico(num)}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                        {errorCalificacionMecanico && <p className="text-red-500 text-sm">{errorCalificacionMecanico}</p>}
                    </div>

                    {/* Tipo de Servicio */}
                    <div className="space-y-4">
                        <label className="block text-lg font-semibold text-gray-700">Tipo de Servicio:</label>
                        <select
                            value={tipoServicio}
                            onChange={(e) => setTipoServicio(e.target.value)}
                            className="w-full text-lg p-4 border-2 border-yellow-500 rounded-lg focus:outline-none"
                            required
                        >
                            <option value="">Selecciona un servicio</option>
                            <option value="Instalación">Instalación</option>
                            <option value="Diagnóstico">Diagnóstico</option>
                            <option value="Corrección de Fallos">Corrección de Fallos</option>
                        </select>
                    </div>

                    {/* Observaciones */}
                    <div>
                        <label className="block font-semibold text-gray-700 mb-2">Observaciones:</label>
                        <textarea
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                            className="w-full text-lg p-4 border-2 border-yellow-500 rounded-lg focus:outline-none"
                        />
                    </div>

                    {/* Política de tratamiento de datos */}
                    <div className="flex items-start space-x-2">
                        <input
                            type="checkbox"
                            checked={aceptaPoliticaDatos}
                            onChange={() => setAceptaPoliticaDatos(!aceptaPoliticaDatos)}
                            className="h-4 w-4 text-yellow-500 border-yellow-500 rounded"
                        />
                        <label className="text-sm font-semibold text-gray-700">
                            Acepto la política de tratamiento de datos personales.
                        </label>
                    </div>

                    {errorPolitica && <p className="text-red-500 text-sm">{errorPolitica}</p>}

                    {/* Botón de envío */}
                    <button
                        type="submit"
                        className={`w-full py-3 text-lg font-semibold text-white ${aceptaPoliticaDatos && !isSubmitting ? 'bg-yellow-500 hover:bg-yellow-600' : 'bg-gray-300 cursor-not-allowed'}`}
                        disabled={!aceptaPoliticaDatos || isSubmitting}
                    >
                        {isSubmitting ? 'Enviando...' : 'Enviar'}
                    </button>

                    {mensaje && <p className="text-green-500 mt-4">{mensaje}</p>}
                </form>
            </div>
        </div>
    );
};

export default EncuestaServicio;
